import { Injectable } from '@angular/core';
import { AuthService, CartService, CustomerProductPrice, GungAnonymousConfigService, GungCurrencyPipe, PriceConfigService, PriceService, ProductService } from 'gung-standard';
import { filter, first } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TyloPriceConfigService extends PriceConfigService {
  public enableHidePrice = true;
  activeGroups: { [s: string]: boolean };

  constructor(protected currencyPipe: GungCurrencyPipe, cartService: CartService, protected authService: AuthService, protected priceService: PriceService, protected productService: ProductService,     protected gungAnonymousConfigService: GungAnonymousConfigService
) {
    super(currencyPipe, cartService, priceService, productService, authService, gungAnonymousConfigService);
    this.authService
      .getCurrentUser()
      .pipe(
        filter(user => !!user),
        first()
      )
      .subscribe(user => {
        this.activeGroups = user.activeGroups;
        this.hidePrice.next(this.activeGroups.NOPRICE);
      });
  }

  public getPrice(
    price: CustomerProductPrice | string,
    mode: string,
    display?: string | boolean,
    currency?: string
  ): string {
    if (this.activeGroups.NOPRICE) {
      return '';
    }
    return super.getPrice(price, mode, display, currency);
  }
}
